import * as Constants from '../../Pages/Constants';
import { withStyles } from '@material-ui/core';
import { useCallback } from 'react';
import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Range, getTrackBackground } from 'react-range';
import PostDataController from '../../Controller/PostDataController.js';

const EQ5DForm = (props) => {

  const { classes } = props;
  const [step, setStep] = useState(0);
  const options = [1,2,3,4,5];
  const [formType, setFormType] = useState({label: "form_type", value:"EQ5D5L"})
  const optionsLabels = ["mobility", "selfcare", "usual_activities", "pain_discomfort", "anxiety_depression", "health_scale"];
  const [optionSelected, setOptionSelected] = useState("0");
  const [message, setMessage] = useState("");
  const [results, setResults] = useState([{label: "registered_by", value:0}, {label: "mobility", value:0}, {label:"selfcare", value:0}, {label:"usual_activities", value:0}, {label:"pain_discomfort", value:0}, {label:"anxiety_depression", value:0}, {label:"health_scale", value:50}]);

  const sendingForm = async () => {
    let to_send = [...results];
    let index = to_send.findIndex(result => result.label === "registered_by")
    to_send[index].value = props.accountInformation.email;
    to_send.unshift(formType);
    let current_Date = new Date()                                                                               // Get current date      
    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient);          // Send data in backend
    await props.update(current_Date, to_send, props.BannerDisplayedAlerts);                                                   // update display
    props.cancelPopup();
  }

  const getRange = () => {
    let index = (results.findIndex(obj => obj.label === "health_scale"))
    return ([results[index].value]);
  }

  const changeRange = (e) => {
    let newResult = [...results];
    let index = (newResult.findIndex(obj => obj.label === optionsLabels[step]))
    newResult[index] = {label:optionsLabels[step], value:e[0]}
    setResults(newResult);
  }

  const changeStep = (direction) => {
    if (direction === "next") {
      if (step === optionsLabels.length-1) {
        sendingForm()
      }
      else {
        if (optionSelected === "0") {
          setMessage(<FormattedMessage id="eq5d.form.error.noselection" defaultMessage="Please select an option."/>)
        }
        else {
          let newResult = [...results];
          let index = (newResult.findIndex(obj => obj.label === optionsLabels[step]))
          newResult[index] = {label:optionsLabels[step], value:parseInt(optionSelected)}
          setResults(newResult);
          setMessage("");
          setOptionSelected(String(newResult[index + 1].value));
          setStep(step+1);
        }
      }
    }
    else if (direction === "previous") {
      setMessage("");
      setStep(step-1);
      setOptionSelected(String(results[step-1].value));
    }
  }

  const toggleCheckbox = (e) => {
    if (optionSelected === e.target.value) {
      setOptionSelected("0")
    } else {
      setOptionSelected(e.target.value)
    }
  }

  const generatePageMobility = () => {
    const lignes = [
      <FormattedMessage id="eq5d.form.mobility.one" defaultMessage="I have no problem in walking about"/>,
      <FormattedMessage id="eq5d.form.mobility.two" defaultMessage="I have slight problems in walking about"/>,
      <FormattedMessage id="eq5d.form.mobility.three" defaultMessage="I have moderate problems in walking about"/>,
      <FormattedMessage id="eq5d.form.mobility.four" defaultMessage="I have severe problems in walking about"/>,
      <FormattedMessage id="eq5d.form.mobility.five" defaultMessage="I am unable to walk about"/>
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="eq5d.form.mobility.title" defaultMessage="Mobility"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {options.map((i) => (
        <div>
          <Row style={{width:"100%", color: "black"}}>
            <Col xs={15}>
              <div style={{textAlign: 'left'}}>
                {lignes[i-1]}
              </div>
            </Col>
            <Col xs={1}>
              <input type="checkbox" name="mobility" value={String(i)} onChange={toggleCheckbox} checked={String(i) === optionSelected}/><br/>
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePageSelfCare = () => {
    const lignes = [
      <FormattedMessage id="eq5d.form.selfcare.one" defaultMessage="I have no problem washing or dressing myself"/>,
      <FormattedMessage id="eq5d.form.selfcare.two" defaultMessage="I have slight problems washing or dressing myself"/>,
      <FormattedMessage id="eq5d.form.selfcare.three" defaultMessage="I have moderate problems washing or dressing myself"/>,
      <FormattedMessage id="eq5d.form.selfcare.four" defaultMessage="I have severe problems washing or dressing myself"/>,
      <FormattedMessage id="eq5d.form.selfcare.five" defaultMessage="I am unable to washing or dressing myself"/>
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="eq5d.form.selfcare.title" defaultMessage="Selfcare"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {options.map((i) => (
        <div>
          <Row style={{width:"100%", color: "black"}}>
            <Col xs={15}>
              <div style={{textAlign: 'left'}}>
                {lignes[i-1]}
              </div>
            </Col>
            <Col xs={1}>
              <input type="checkbox" name="selfcare" value={String(i)} onChange={toggleCheckbox} checked={String(i) === optionSelected}/><br/>
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePageUsualActivities = () => {
    const lignes = [
      <FormattedMessage id="eq5d.form.usualactivities.one" defaultMessage="I have no problem doing my usual activities"/>,
      <FormattedMessage id="eq5d.form.usualactivities.two" defaultMessage="I have slight problems doing my usual activities"/>,
      <FormattedMessage id="eq5d.form.usualactivities.three" defaultMessage="I have moderate problems doing my usual activities"/>,
      <FormattedMessage id="eq5d.form.usualactivities.four" defaultMessage="I have severe problems doing my usual activities"/>,
      <FormattedMessage id="eq5d.form.usualactivities.five" defaultMessage="I am unable to do my usual activities"/>
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="eq5d.form.usualactivities.title" defaultMessage="Usual activities"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {options.map((i) => (
        <div>
          <Row style={{width:"100%", color: "black"}}>
            <Col xs={15}>
              <div style={{textAlign: 'left'}}>
                {lignes[i-1]}
              </div>
            </Col>
            <Col xs={1}>
              <input type="checkbox" name="usualactivities" value={String(i)} onChange={toggleCheckbox} checked={String(i) === optionSelected}/><br/>
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePagePainDiscomfort = () => {
    const lignes = [
      <FormattedMessage id="eq5d.form.paindiscomfort.one" defaultMessage="I have no pain or discomfort"/>,
      <FormattedMessage id="eq5d.form.paindiscomfort.two" defaultMessage="I have slight pain or discomfort"/>,
      <FormattedMessage id="eq5d.form.paindiscomfort.three" defaultMessage="I have moderate pain or discomfort"/>,
      <FormattedMessage id="eq5d.form.paindiscomfort.four" defaultMessage="I have severe pain or discomfort"/>,
      <FormattedMessage id="eq5d.form.paindiscomfort.five" defaultMessage="I have extreme pain or discomfort"/>
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="eq5d.form.paindiscomfort.title" defaultMessage="Pain / Discomfort"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {options.map((i) => (
        <div>
          <Row style={{width:"100%", color: "black"}}>
            <Col xs={15}>
              <div style={{textAlign: 'left'}}>
                {lignes[i-1]}
              </div>
            </Col>
            <Col xs={1}>
              <input type="checkbox" name="paindiscomfort" value={String(i)} onChange={toggleCheckbox} checked={String(i) === optionSelected}/><br/>
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePageAnxietyDepression = () => {
    const lignes = [
      <FormattedMessage id="eq5d.form.anxietydepression.one" defaultMessage="I am not anxious or depressed"/>,
      <FormattedMessage id="eq5d.form.anxietydepression.two" defaultMessage="I am slightly anxious or depressed"/>,
      <FormattedMessage id="eq5d.form.anxietydepression.three" defaultMessage="I am moderately anxious or depressed"/>,
      <FormattedMessage id="eq5d.form.anxietydepression.four" defaultMessage="I am severely anxious or depressed"/>,
      <FormattedMessage id="eq5d.form.anxietydepression.five" defaultMessage="I am extremely anxious or depressed"/>
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="eq5d.form.anxietydepression.title" defaultMessage="Anxiety / Depression"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {options.map((i) => (
        <div>
          <Row style={{width:"100%", color: "black"}}>
            <Col xs={15}>
              <div style={{textAlign: 'left'}}>
                {lignes[i-1]}
              </div>
            </Col>
            <Col xs={1}>
              <input type="checkbox" name="anxietydepression" value={String(i)} onChange={toggleCheckbox} checked={String(i) === optionSelected}/><br/>
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePageHealthScale = () => {
    return (
      <div style={{color: "black"}}>
        <Row style={{width:"100%", color: "black"}}>
          <Col xs={15}>
            <ul style={{"text-align": "left"}}>
              <li>
                <FormattedMessage id="eq5d.form.healthscale.introduction" defaultMessage="We would like to know how good or bad your health is TODAY"/>
              </li>
              <li>
                <FormattedMessage id="eq5d.form.healthscale.scalenumbers" defaultMessage="This scale is numbered from 0 to 100."/>
              </li>
              <li>
                <FormattedMessage id="eq5d.form.healthscale.onehundredmeans" defaultMessage="100 means the best health you can imagine."/>
                <br/>
                <FormattedMessage id="eq5d.form.healthscale.zeromeans" defaultMessage="0 means the worst health you can imagine."/>
              </li>
              <li>
                <FormattedMessage id="eq5d.form.healthscale.instruction" defaultMessage="Please click on the scale to indicate how your health is TODAY."/>
              </li>
            </ul>
            <div style={{backgroundColor: "black", color: "white"}}>
                <FormattedMessage id="eq5d.form.healthscale.yourhealthtoday" defaultMessage="YOUR HEALTH TODAY = "/>
                {getRange()}
            </div>
          </Col>
          <Col xs={9}>
            <Range
              values={getRange()}
              step={1}
              min={0}
              max={100}
              onChange={(values) => changeRange(values)}
              renderTrack={({ props, children }) => (
                <div
                  onMouseDown={props.onMouseDown}
                  onTouchStart={props.onTouchStart}
                  style={{
                    ...props.style,
                    height: "36px",
                    display: "flex",
                    width: "100%"
                  }}
                >
                  <div
                    ref={props.ref}
                    style={{
                      height: "5px",
                      width: "100%",
                      borderRadius: "4px",
                      background: getTrackBackground({
                        values: getRange(),
                        colors: ["#ccc", "#ccc"], //change the first to change the left part of the bar
                        min: 0,
                        max: 100
                      }),
                      alignSelf: "center",
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
              renderThumb={({ props, isDragged }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: "30px",
                    width: "30px",
                    borderRadius: "4px",
                    backgroundColor: "#FFF", //color of the button
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "0px 2px 6px #AAA"
                  }}
                >
                  <div
                    style={{
                      height: "16px",
                      width: "5px",
                      backgroundColor: "#CCC"
                    }}
                  />
                </div>
              )}
            />
          </Col>
        </Row>
      </div>
    )
  }

  const generatePage = () => {
    switch(step) {
    case 0 :
      return (generatePageMobility())
    case 1 :
      return (generatePageSelfCare())
    case 2 :
      return (generatePageUsualActivities())
    case 3 :
      return (generatePagePainDiscomfort())
    case 4 :
      return (generatePageAnxietyDepression())
    case 5 :
      return (generatePageHealthScale())
    default :
      return (null);
    }
  }

  const generateStep = () => {
    return (
      <div>
        <Row style={{ display: 'flex', justifyContent: 'center', fontWeight: "bold", fontSize:"2.2em", color: "black"}}>
            <FormattedMessage id="eq5d.form.title.main" defaultMessage="Health Questionnaire"/>
        </Row>
        <br/>
        <Row style={{ color: "black"}}>
          <FormattedMessage id="eq5d.form.instruction.page" defaultMessage="Please select the ONE box that best describes your health TODAY."/>
        </Row>
        <br/>
        {generatePage()}
        <br/>
        <Button
          disabled={step===0}
          variant="contained"
          color="default"
          startIcon={<ArrowBackIcon />}
           onClick={() => changeStep("previous")}
        >
          <FormattedMessage id="eq5d.form.arrow.previous" defaultMessage="Previous"/>
        </Button>
        <Button
          variant="contained"
          color="default"
          startIcon={<ArrowForwardIcon />}
           onClick={() => changeStep("next")}
        >
          <FormattedMessage id="eq5d.form.arrow.next" defaultMessage="Next"/>
        </Button>
      </div>
    )
  }

  let generalFormWidth = "75%"
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%"
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width:{generalFormWidth}, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          {generateStep()}
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        </div>
      </div>
    </div>
  );

}
export default withStyles(Constants.styles)(EQ5DForm);
